<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ea_code }}</em>
          </div>
        </div>

        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="ea_tel">
            <label class="weui-form-preview__label">{{
              customLabel.ea_tel || "候选人姓名"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.ea_name }}
              <call-mobile :mobile="form.main.ea_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ea_sex">
            <label class="weui-form-preview__label">{{
              customLabel.ea_sex || "性别"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ea_sex }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_department">
            <label class="weui-form-preview__label">{{
              customLabel.ea_department || "应聘部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_department
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_position">
            <label class="weui-form-preview__label">{{
              customLabel.ea_position || "应聘岗位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_position
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_level">
            <label class="weui-form-preview__label">{{
              customLabel.ea_level || "应聘员工级别"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_level
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_xl">
            <label class="weui-form-preview__label">{{
              customLabel.ea_xl || "学历"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ea_xl }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_zy">
            <label class="weui-form-preview__label">{{
              customLabel.ea_zy || "专业"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ea_zy }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_byschool">
            <label class="weui-form-preview__label">{{
              customLabel.ea_byschool || "毕业院校"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_byschool
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_bydate">
            <label class="weui-form-preview__label">{{
              customLabel.ea_bydate || "毕业时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ea_bydate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_workyear">
            <label class="weui-form-preview__label">{{
              customLabel.ea_workyear || "工作年限"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_workyear
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="form.main.ea_lcompany"
      >
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ea_lcompany">
            <label class="weui-form-preview__label">{{
              customLabel.ea_lcompany || "上一公司名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_lcompany
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_lworkyear">
            <label class="weui-form-preview__label">{{
              customLabel.ea_lworkyear || "工作时长（年）"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_lworkyear
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_ljob">
            <label class="weui-form-preview__label">{{
              customLabel.ea_ljob || "任职岗位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_ljob
            }}</span>
          </div>
        </custom-layout>
    </div>
      <div class="form-preview weui-form-preview">
      <div class="weui-form-preview__bd">
        <custom-layout :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ea_systartdate">
            <label class="weui-form-preview__label">{{
              customLabel.ea_systartdate || "试用期起始时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ea_systartdate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_syenddate">
            <label class="weui-form-preview__label">{{
              customLabel.ea_syenddate || "截止时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ea_syenddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ea_sysalary">
            <label class="weui-form-preview__label">{{
              customLabel.ea_sysalary || "试用期薪资"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ea_sysalary }} 元</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ea_salary">
            <label class="weui-form-preview__label">{{
              customLabel.ea_salary || "转正薪资"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ea_salary }} 元</span
            >
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.ea_remark"
            slot="ea_remark"
          >
            <label class="weui-form-preview__label">{{
              customLabel.ea_remark || "其他约定"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ea_remark
            }}</span>
          </div>
        </custom-layout>
      </div>
      </div>
      <file-list v-model="form.main.ea_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/oa/entryapply",
      codeField: "ea_code",
      statusField: "ea_statuscode",
      caller: "Entryapply",
      xtype: "oa-entryapply-formpanel",
    };
  },
};
</script>